export function get_api() {
    return (
        {

            'admin_api': 'https://script.google.com/macros/s/AKfycbwdreNuoGfxnRzvFTDFjjPeYgT1Ekj7bizxq3mZzPb5XGsQUBAEoSV_Ia425ongDgiHDQ/exec',

            //set student api
            'student_api': 'https://script.google.com/macros/s/AKfycbweGk1X69PSdUr5Hl5rLfHIS6Eoq1ENfZ_r4y3-LN72MDHqTqirs-rfmVXT-p4qg17-/exec',
            //set teacher api
            'teacher_api': 'https://script.google.com/macros/s/AKfycbxmlWGjsetThYh4iuz3RYfrz9ha1My6qYn3BXrnYJew3_y8iyRlzLYdpK8hSYqUkfF-/exec'

        }
    )
}